import { createStackNavigator } from "@react-navigation/stack";
import { SCREENS } from "navigation/consts";
import Scanner from "views/Scanner";

import { ScannerNavigationParamList } from "./types";

const { Navigator, Screen } =
  createStackNavigator<ScannerNavigationParamList>();

const ScannerNavigation: React.FC = () => (
  <Navigator screenOptions={{ headerTitleAlign: "center" }}>
    <Screen name={SCREENS.Scanner} component={Scanner} />
  </Navigator>
);

export default ScannerNavigation;
